import { useState, useRef, useEffect } from 'react';
export function useWebRTC() {
    const [isConnected, setIsConnected] = useState(false);
    const [localStream, setLocalStream] = useState(null);
    const [remoteStream, setRemoteStream] = useState(null);
    const peerConnectionRef = useRef(null);
    const initializeWebRTC = async () => {
        try {
            // Get user media
            const stream = await navigator.mediaDevices.getUserMedia({
                audio: true,
                video: false, // Audio only for now
            });
            setLocalStream(stream);
            // Create peer connection (simplified - should use proper signaling)
            const pc = new RTCPeerConnection({
                iceServers: [
                    { urls: 'stun:stun.l.google.com:19302' },
                ],
            });
            // Add local stream tracks
            stream.getTracks().forEach((track) => {
                pc.addTrack(track, stream);
            });
            // Handle remote stream
            pc.ontrack = (event) => {
                setRemoteStream(event.streams[0]);
            };
            pc.onconnectionstatechange = () => {
                setIsConnected(pc.connectionState === 'connected');
            };
            peerConnectionRef.current = pc;
        }
        catch (err) {
            console.error('Failed to initialize WebRTC:', err);
        }
    };
    const closeWebRTC = () => {
        if (localStream) {
            localStream.getTracks().forEach((track) => track.stop());
            setLocalStream(null);
        }
        if (peerConnectionRef.current) {
            peerConnectionRef.current.close();
            peerConnectionRef.current = null;
        }
        setRemoteStream(null);
        setIsConnected(false);
    };
    useEffect(() => {
        return () => {
            closeWebRTC();
        };
    }, []);
    return {
        isConnected,
        localStream,
        remoteStream,
        initializeWebRTC,
        closeWebRTC,
    };
}
